import {AxiosError} from 'axios';
import {UpcomingSubjectPaperDetail} from '../../models/UpcomingSubjectPaper';
import {GET_UPCOMING_SUBJECT_PAPER_URL} from '../../constants/apiUrls';
import {GET_UPCOMING_SUBJECT_PAPER_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../../hooks/query';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: UpcomingSubjectPaperDetail[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetUpcomingSubjectPapers = ({onSuccess, onError}: Input = {}) => {
  const getUpcomingSubjectPapers = async () => {
    const res = await axiosClient.get<UpcomingSubjectPaperDetail[]>(GET_UPCOMING_SUBJECT_PAPER_URL);
    return res.data;
  };

  return useCustomQuery(GET_UPCOMING_SUBJECT_PAPER_KEY, getUpcomingSubjectPapers, {
    onSuccess,
    onError,
  });
};
